import React from "react";

interface PropsI {
  className?: string;
  isOn: boolean;
  handleToggle: () => void;
  colorOne?: string;
  colorTwo?: string;
  disabled?: boolean;
}
// ... (rest of the code)

const BaseSwitch = ({
  className,
  isOn,
  handleToggle,
  colorOne = "#305F32",
  colorTwo = "#D9E9DA",
  disabled = false,
}: PropsI) => {
  return (
    <div className={`switch-container ${className}`}>
      <input
        checked={isOn}
        onChange={handleToggle} // Call the handleToggle function on change
        className="switch-checkbox"
        id={`switch`}
        type="checkbox"
        disabled={disabled}
      />
      <label
        style={{
          background: isOn ? colorOne : colorTwo,
          cursor: disabled ? "not-allowed" : "pointer", // Set cursor style
          opacity: disabled ? 0.5 : 1, // Reduce opacity when disabled
        }}
        className={`switch-label ${disabled ? "switch-label-disabled" : ""}`} // Add a class for disabled styling
        htmlFor={`switch`}
      >
        <span
          className={`switch-button ${disabled ? "switch-button-disabled" : ""}`} // Add a class for disabled styling
        />
      </label>
    </div>
  );
};

export default BaseSwitch;
